import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { queryUserEducation } from '@/services/user/query'

import { KeyValue } from '@/components/ui/key-value'

import { formatDateOnly, formatMonthYear } from '@/lib/utils/utils'

export const Route = createFileRoute('/dashboard/education')({
  component: RouteComponent,
})

function RouteComponent() {
  const eduQry = useSuspenseQuery(queryUserEducation())
  const educations = eduQry.data

  return (
    <div className="rounded-lg border-t-4 border-yes-600 bg-background">
      <div className="border-b px-4 py-4">
        <h2 className="font-semibold">Pendidikan</h2>
      </div>
      <div className="divide-y divide-gray-200 px-4">
        {educations?.map(
          ({
            id,
            school,
            level,
            major,
            start_date,
            graduation_date,
            cumulative_grade,
            country,
          }) => {
            let dateStr = ''
            if (start_date) dateStr += formatMonthYear(start_date)
            dateStr += ' - '
            if (graduation_date) dateStr += formatMonthYear(graduation_date)
            else dateStr += 'Sekarang'
            return (
              <div key={id} className="grid grid-cols-2 gap-4 py-4">
                <KeyValue
                  label="Tingkat Pendidikan"
                  value={level || '-'}
                  className="col-span-full"
                />
                <KeyValue
                  label="Nama Sekolah/Kampus"
                  value={school || '-'}
                  className="col-span-full"
                />
                <KeyValue
                  label="Negara"
                  value={country || '-'}
                  className="col-span-full"
                />
                <KeyValue
                  label="Bidang Studi"
                  value={major || '-'}
                  className="col-span-full"
                />
                <KeyValue
                  label="Tanggal Masuk - Lulus"
                  value={dateStr}
                  className="col-span-full"
                />
                <KeyValue
                  label="Nilai Kumulatif"
                  value={cumulative_grade || '-'}
                  className="col-span-full"
                />
              </div>
            )
          }
        )}
      </div>
    </div>
  )
}
